export default __webpack_public_path__ + "static/Genuine Accessories – Horizontal 800x400-a6c270b55108ee83c2421eaf9aac6293.svg";